import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useEffect, useContext, useState } from "react";
import { adminContext } from "../../../context/admincontext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { getAllZones } from "../../../services/kojaServices";
import { toast } from "react-hot-toast";
import { uploadUrl, downloadUrl } from "../../../confing/confing";
import axios from "axios";
import Swal from "sweetalert2";
import { AddExperts, chackUserName } from "../../../services/adminServices";
import { addExpertSchema } from "../../../validation/validation";

const AddExpert = () => {
  const { setPage } = useContext(adminContext);
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("ثبت کارشناس");
        const { data: zones } = await getAllZones();
        setZones(zones.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  let selectfile = async (e, setFieldValue, name) => {
    try {
      setLoading(true);
      console.log(name);
      const imageFile = e.target.files[0];
      if (imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
        let size = (imageFile.size / 1024 / 1024).toFixed(2);
        if (size <= 3) {
          let datas = new FormData();
          datas.append("file", e.target.files[0]);
          const { data } = await axios.post(`${uploadUrl}`, datas);
          console.log(data);
          setFieldValue(name, data.result.fileName);
          toast.success("تصویر با موفقیت اپلود شد");
          setLoading(false);
        } else {
          toast.error("سایز عکس باید کمتر از 2 مگابایت باشد");
          setLoading(false);
        }
      } else {
        toast.error("فرمت عکس قابل قبول نیست");
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("دوباره تلاش کنید");
      setLoading(false);
    }
  };
  const submitForm = async (values) => {
    try {
      console.log(values);
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      console.log({ type: "expert", username: values.userName });
      const { data: UserName } = await chackUserName({
        type: "expert",
        username: values.userName,
      });
      const { data } = await AddExperts(values);
      let text = data.result_message;
      Swal.close();
      Swal.fire({
        icon: "success",
        title: `${text}`,
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (err) {
      if (err.response.status === 406) {
        toast.error("نام کاربری قبلا ثبت شده است");
      }
      console.log(err);
      toast.error("درخواست شما نجام نشد لطفا مجددا امتحان کنید");
      Swal.close();
    }
  };
  return (
    <div style={{ paddingTop: "10px" }} className="add-expert-page">
      <Header />
      <div className="d-flex content-box">
        <Menu />
        <div className="w-100 me-lg-3 ms-lg-5 text-end">
          <h3>ثبت کارشناس</h3>
          <div
            className="p-3 w-100"
            style={{
              backgroundColor: "rgba(179, 198, 205, 0.50)",
              borderRadius: "25px",
            }}
          >
            <Formik
              initialValues={{
                name: "",
                mobile: "",
                type: "",
                userName: "",
                password: "",
                reqPassword: "",
                agencyTel: "",
                agencyAddress: "",
                agencyName: "",
                ExZoneId: "",
                pic: "",
                parvane: "",
                sheba: "",
                stamp: "",
              }}
              validationSchema={addExpertSchema}
              onSubmit={(values, { resetForm }) => {
                submitForm(values);
              }}
              enableReinitialize={true}
            >
              {({
                isSubmitting,
                errors,
                setFieldValue,
                handleChange,
                touched,
                values
              }) => (
                <Form>
                  <div className="row  align-items-center justify-content-between text-end">
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>نام ونام خانوادگی:</label>
                      <Field
                        name="name"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="name"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>شماره موبایل:</label>
                      <Field
                        name="mobile"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="mobile"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>شماره شبا : </label>
                      <Field
                        name="sheba"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="sheba"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>نام کاربری: </label>
                      <Field
                        name="userName"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="userName"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>رمز عبور:</label>
                      <Field
                        name="password"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="password"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>تکرار رمز عبور:</label>
                      <Field
                        name="reqPassword"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="reqPassword"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>نام دفتر:</label>
                      <Field
                        name="agencyName"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="agencyName"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>نوع کارشناس</label>
                      <Field
                        name="type"
                        className="w-100 add-realestate-input px-2 "
                        as="select"
                      >
                        <option>لطفا یک گزینه انتخاب کنید</option>
                        <option value="Formal">محلی</option>
                        <option value="Local">رسمی</option>
                      </Field>
                      <ErrorMessage
                        name="type"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-6">
                      <label>نشانی دفتر: </label>
                      <Field
                        name="agencyAddress"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="agencyAddress"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>شماره تماس دفتر: </label>
                      <Field
                        name="agencyTel"
                        className="w-100 add-realestate-input px-2 "
                        type="text"
                      />
                      <ErrorMessage
                        name="agencyTel"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>منطقه : </label>
                      <Field
                        name="ExZoneId"
                        className="w-100 add-realestate-input px-2 "
                        as="select"
                      >
                        <option>لطفا یک گزینه انتخاب کنید</option>
                        {zones.map((s, index) => (
                          <option key={index} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="ExZoneId"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-3">
                      {loading && (
                        <div>
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          <span>منتظر بمانید</span>
                        </div>
                      )}
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>تصویر پرونده کارشناسی: </label>
                      {values.parvane && (
                        <img
                          alt=""
                          className="mb-2"
                          width="90%"
                          height={80}
                          src={`${downloadUrl}${values.parvane}`}
                        />
                      )}

                      <div>
                        <label htmlFor="parvane">
                          <span
                            className="btn me-3"
                            style={{
                              backgroundColor: "#6BBA81",
                              color: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            آپلود فایل
                          </span>
                        </label>
                       
                        <input
                          type="file"
                          id="parvane"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            selectfile(e, setFieldValue, "parvane");
                          }}
                        ></input>
                        <ErrorMessage
                          name="parvane"
                          render={(msg) => (
                            <div className="text-danger">{msg}</div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-3">
                      <label>تصویر کارشناس:</label>
                      {values.pic && (
                        <img
                          alt=""
                          className="mb-2"
                          width="90%"
                          height={80}
                          src={`${downloadUrl}${values.pic}`}
                        />
                      )}
                      <div>
                        <label htmlFor="pic">
                          <span
                            className="btn me-3"
                            style={{
                              backgroundColor: "#6BBA81",
                              color: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            آپلود فایل
                          </span>
                        </label>
                      
                        <input
                          type="file"
                          id="pic"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            selectfile(e, setFieldValue, "pic");
                          }}
                        ></input>
                        <ErrorMessage
                          name="pic"
                          render={(msg) => (
                            <div className="text-danger">{msg}</div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="mb-5 col-6 col-md-4 col-lg-4">
                      <label>تصویر مهر و امضا:</label>
                      {values.stamp && (
                        <img
                          alt=""
                          width="90%"
                          height={80}
                          className="mb-2"
                          src={`${downloadUrl}${values.stamp}`}
                        />
                      )}
                      <div>
                        <label htmlFor="stamp">
                          <span
                            className="btn me-3"
                            style={{
                              backgroundColor: "#6BBA81",
                              color: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            آپلود فایل
                          </span>
                        </label>
                        <div className="my-2">
                        
                        </div>
                        <input
                          type="file"
                          id="stamp"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            selectfile(e, setFieldValue, "stamp");
                          }}
                        />
                        <ErrorMessage
                          name="stamp"
                          render={(msg) => (
                            <div className="text-danger">{msg}</div>
                          )}
                        />
                      </div>
                    </div>

                    <div className="text-start ">
                      <button
                        className="btn"
                        style={{
                          width: "200px",
                          backgroundColor: "#6BBA81",
                          borderRadius: "20px",
                        }}
                      >
                        ثبت
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddExpert;
